import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'shared';
import { NavMenuComponent } from './nav-menu/nav-menu.component';

@NgModule({
    declarations: [HeaderComponent, NavMenuComponent],
    imports: [CommonModule, IonicModule, SharedModule],
    exports: [HeaderComponent, NavMenuComponent],
})
export class HeaderModule {}
